import { lazy } from "react";

const Product = lazy(() => import("../pages/product"));
const ProductPreview = lazy(() => import("../pages/preview/product"));
const ProductComponentDetail = lazy(() => import("../pages/detail/product"));

export const productRoutes = [
  { path: "/product/:productId", element: <Product /> },
  { path: "/product/:productId/preview", element: <ProductPreview /> },
  { path: "/product/detail/:componentId", element: <ProductComponentDetail /> },
];